import { createAction } from '@reduxjs/toolkit';

export const imageUpdateRequest = createAction('emailsImage/updateRequest');
export const imageUpdateError = createAction('emailsImage/updateError');
export const imageUpdateStore = createAction('emailsImage/updateStore');

export const imageStore = createAction('emailsImage/store');
export const imageClear = createAction('emailsImage/clear');

export const imageUpdateId = createAction('emailsImage/updateId');
export const imageUpdateIsActive = createAction('emailsImage/updateIsActive');

export const imageUpdateAspectRatio = createAction('emailsImage/updateAspectRatio');
export const imageUpdateImg = createAction('emailsImage/updateImg');
export const imageUpdateIsFullWidth = createAction('emailsImage/updateIsFullWidth');
export const imageUpdateUrl = createAction('emailsImage/updateUrl');
